// extracted by mini-css-extract-plugin
export default {"-large":"sc6B2d2ajPjNLyPTFo8T","container":"GGB5zGLOf2MVh6GlNvfN","pickingMode":"EybPEae6EeJDlNAyU7IQ","bottomContent":"Nzjw4GM4kbrGpvaRmnqA","addTopShadow":"AsTK2EhgfeQC03m1LDti"};